import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";

var _templateObject;

import "core-js/modules/es6.function.name.js";
import { gql } from '@nerdwallet/apollo';

var getInsuranceOfferV2Schema = function getInsuranceOfferV2Schema(offer) {
  var _offer$product, _offer$product$instit, _offer$product2, _offer$product2$insti, _offer$product3, _offer$product3$insti, _offer$product4, _offer$product4$insti;

  var name = (offer === null || offer === void 0 ? void 0 : offer.displayName) || (offer === null || offer === void 0 ? void 0 : (_offer$product = offer.product) === null || _offer$product === void 0 ? void 0 : (_offer$product$instit = _offer$product.institution) === null || _offer$product$instit === void 0 ? void 0 : _offer$product$instit.name);
  var aggregateRating = (offer === null || offer === void 0 ? void 0 : offer.starRating) || (offer === null || offer === void 0 ? void 0 : (_offer$product2 = offer.product) === null || _offer$product2 === void 0 ? void 0 : (_offer$product2$insti = _offer$product2.institution) === null || _offer$product2$insti === void 0 ? void 0 : _offer$product2$insti.starRating);
  var logo = (offer === null || offer === void 0 ? void 0 : (_offer$product3 = offer.product) === null || _offer$product3 === void 0 ? void 0 : (_offer$product3$insti = _offer$product3.institution) === null || _offer$product3$insti === void 0 ? void 0 : _offer$product3$insti.imageSource) || (offer === null || offer === void 0 ? void 0 : offer.imageSource);
  var review = (offer === null || offer === void 0 ? void 0 : offer.bottomLineText) || (offer === null || offer === void 0 ? void 0 : (_offer$product4 = offer.product) === null || _offer$product4 === void 0 ? void 0 : (_offer$product4$insti = _offer$product4.institution) === null || _offer$product4$insti === void 0 ? void 0 : _offer$product4$insti.tagline);
  var schema = {
    '@type': 'InsuranceAgency',
    name: name
  };

  if (review) {
    schema.review = {
      '@type': 'Review',
      reviewBody: review
    };
  }

  if (aggregateRating) {
    schema.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: aggregateRating,
      bestRating: 5
    };
  }

  if (logo) {
    schema = _objectSpread(_objectSpread({}, schema), {}, {
      logo: logo,
      image: logo
    });
  }

  return schema;
};

getInsuranceOfferV2Schema.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment getInsuranceOfferV2Schema on InsuranceOfferV2 {\n    displayName\n    starRating\n    imageSource\n    bottomLineText\n    tagline\n    product {\n      institution {\n        name\n        starRating\n        imageSource\n        tagline\n      }\n    }\n  }\n"])));
export default getInsuranceOfferV2Schema;